/*
 * Bonusprogramm: Rechner der Landingpage und Schaltflächen, die das
 * Prämien-Widget öffnen.
 *
 * Das Widget wird von der App gestellt, geöffnet wird es auf zwei Wegen.
 * Greift keiner davon, bleibt der Link der Schaltfläche wirksam und führt
 * auf die Bonusseite.
 */
(function () {
	/*
	 * Weg 1: Das JavaScript-SDK von Smile. Es liegt nur auf der Seite, wenn es
	 * in Smile Admin unter Settings > Developer Tools freigeschaltet wurde.
	 * Die Namen hier sind geraten, Smile veröffentlicht keine Methodenliste.
	 * Ohne Freischaltung existiert weder Smile noch SmileUI, dann läuft die
	 * Schleife leer durch und Weg 2 übernimmt.
	 */
	const WIDGET_OPENERS = [
		["SmileUI", "openChannel"],
		["SmileUI", "openPanel"],
		["SmileUI", "open"],
		["Smile", "openPanel"],
		["Smile", "open"],
	];

	/*
	 * Weg 2: Deep Link. Smile öffnet das Panel, wenn der Seitenanker auf einen
	 * seiner Abschnitte zeigt. Das ist der dokumentierte Weg für Links auf der
	 * Seite und braucht kein freigeschaltetes SDK.
	 *
	 * Andere Ziele wären smile-points-activity-rules für die Verdienstmöglich-
	 * keiten, smile-points-products für die Prämien und
	 * smile-referral-program-details für das Empfehlungsprogramm. Hier steht
	 * bewusst die Übersicht, der Auslöser ist eine allgemeine Überschrift.
	 */
	const SMILE_DEEP_LINK = "smile-home";

	// Der Lader liegt auch ohne freigeschaltetes SDK auf der Seite. Er ist
	// deshalb das verlässlichere Zeichen dafür, dass Smile überhaupt da ist.
	const smileIsPresent = () =>
		typeof window.loadSmileSdk === "function" ||
		typeof window.__smile_ui_init_data__ !== "undefined";

	const openViaDeepLink = () => {
		if (!smileIsPresent()) return false;

		// Steht der Anker schon auf dem Ziel, etwa weil das Panel vorhin
		// geöffnet und wieder geschlossen wurde, löst ein erneutes Setzen
		// kein hashchange aus. Deshalb vorher zurücksetzen.
		if (window.location.hash === "#" + SMILE_DEEP_LINK) {
			window.history.replaceState(
				null,
				"",
				window.location.pathname + window.location.search,
			);
		}

		window.location.hash = SMILE_DEEP_LINK;
		return true;
	};

	const openRewardsWidget = () => {
		const openedViaSdk = WIDGET_OPENERS.some(function (opener) {
			const api = window[opener[0]];

			if (api && typeof api[opener[1]] === "function") {
				api[opener[1]]();
				return true;
			}

			return false;
		});

		return openedViaSdk || openViaDeepLink();
	};

	/*
	 * Die Beträge des Bonusprogramms stehen als Eurowerte fest und erscheinen
	 * überall in der Schreibweise des deutschen Marktes, Komma vor den Cent und
	 * Zeichen dahinter. Damit stimmen sie mit dem überein, was der money-Filter
	 * und snippets/loyalty-money.liquid serverseitig ausgeben, auch wenn die
	 * Seite gerade in einer anderen Sprache läuft.
	 */
	const MONEY_LOCALE = "de-DE";

	const formatMoney = (cents, currency) => {
		const amount = (Number(cents) || 0) / 100;

		try {
			return new Intl.NumberFormat(MONEY_LOCALE, {
				style: "currency",
				currency: currency,
			}).format(amount);
		} catch (error) {
			return amount.toFixed(2);
		}
	};

	const initCalculator = (calculator) => {
		if (calculator.dataset.loyaltyReady === "true") return;
		calculator.dataset.loyaltyReady = "true";

		const input = calculator.querySelector("[data-loyalty-calculator-input]");
		const pointsOutput = calculator.querySelector("[data-loyalty-calculator-points]");
		const valueOutput = calculator.querySelector("[data-loyalty-calculator-value]");

		if (!input || !pointsOutput || !valueOutput) return;

		const rate = parseFloat(calculator.dataset.rate) || 1;
		const pointValue = parseFloat(calculator.dataset.pointValue) || 1;
		const locale = calculator.dataset.locale || "de";
		const currency = calculator.dataset.currency || "EUR";

		const update = () => {
			const entered = parseFloat(String(input.value).replace(",", "."));
			const orderValue = isNaN(entered) || entered < 0 ? 0 : entered;
			// Smile rundet auf volle Punkte, siehe docs/bonusprogramm.md
			const points = Math.round(orderValue * rate);

			pointsOutput.textContent = points.toLocaleString(locale);
			valueOutput.textContent = formatMoney(points * pointValue, currency);
		};

		input.addEventListener("input", update);
		update();
	};

	const initWidgetTrigger = (trigger) => {
		if (trigger.dataset.loyaltyReady === "true") return;
		trigger.dataset.loyaltyReady = "true";

		trigger.addEventListener("click", function (event) {
			if (openRewardsWidget()) {
				event.preventDefault();
			}
		});
	};

	/*
	 * Kurs des Marktes, in dem die Seite gerade läuft. Shopify legt ihn auf
	 * jeder Storefront ab, in der Shop-Währung steht dort eins. Ist der Wert
	 * nicht zu gebrauchen, kommt null zurück, dann wird nicht gerechnet.
	 */
	const currencyRate = () => {
		const shopify = window.Shopify || {};
		const rate = parseFloat(shopify.currency && shopify.currency.rate);

		return Number.isFinite(rate) && rate > 0 ? rate : 0;
	};

	/*
	 * Punkteanzeige auf der Produktseite.
	 *
	 * Das Theme meldet jeden Variantenwechsel als CustomEvent "variant:change"
	 * auf document, mitgeliefert wird die vollständige Variante inklusive Preis
	 * in Cent, siehe assets/global.js. Das Element selbst wird beim Wechsel
	 * nicht ausgetauscht, der Listener bleibt also bestehen.
	 *
	 * Der Preis kommt in der Währung des Marktes, gerechnet wird aber immer in
	 * der Währung des Shops, so hält es auch Smile. Außerhalb der Shop-Währung
	 * steht deshalb data-needs-rate am Element: Liquid konnte die Punktezahl
	 * dort nicht ausgeben, sie wird hier über den Kurs nachgeholt und der
	 * Zahlenteil an die Stelle des Ersatztextes gesetzt.
	 */
	const initProductLoyalty = (element) => {
		if (element.dataset.loyaltyReady === "true") return;
		element.dataset.loyaltyReady = "true";

		const pointsOutputs = element.querySelectorAll("[data-loyalty-product-points]");
		const valueOutputs = element.querySelectorAll("[data-loyalty-product-value]");

		if (!pointsOutputs.length && !valueOutputs.length) return;

		const pointsRate = parseFloat(element.dataset.rate) || 1;
		const pointValue = parseFloat(element.dataset.pointValue) || 1;
		const locale = element.dataset.locale || "de";
		const currency = element.dataset.currency || "EUR";
		const sectionId = element.dataset.section;
		const needsRate = element.dataset.needsRate === "true";
		const rate = needsRate ? currencyRate() : 1;

		// Ohne brauchbaren Kurs bleibt es beim Ersatztext. Eine Zahl wäre dort
		// geraten, und zu hoch geraten ist schlechter als gar keine.
		if (needsRate && !rate) return;

		const update = (price) => {
			// Smile rundet auf volle Punkte, siehe docs/bonusprogramm.md
			const points = Math.round((price / 100 / rate) * pointsRate);

			pointsOutputs.forEach(function (output) {
				output.textContent = points.toLocaleString(locale);
			});

			valueOutputs.forEach(function (output) {
				output.textContent = formatMoney(points * pointValue, currency);
			});
		};

		if (needsRate) {
			const figures = element.querySelector("[data-loyalty-figures]");
			const fallback = element.querySelector("[data-loyalty-fallback]");

			update(parseFloat(element.dataset.price) || 0);

			if (figures) figures.hidden = false;
			if (fallback) fallback.hidden = true;
		}

		document.addEventListener("variant:change", function (event) {
			const detail = event.detail || {};
			const variant = detail.variant;

			if (sectionId && detail.sectionId && String(detail.sectionId) !== sectionId) return;
			if (!variant || typeof variant.price !== "number") return;

			element.dataset.price = variant.price;
			update(variant.price);
		});
	};

	const initLoyalty = () => {
		document.querySelectorAll("[data-loyalty-calculator]").forEach(initCalculator);
		document.querySelectorAll("[data-loyalty-widget]").forEach(initWidgetTrigger);
		document.querySelectorAll("[data-loyalty-product]").forEach(initProductLoyalty);
	};

	document.addEventListener("shopify:section:load", initLoyalty);

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initLoyalty);
	} else {
		initLoyalty();
	}
})();
